<app-content-blocks [fetchFunction]="pageService.getPageBySlug.bind(pageService)" />

@if (pageIsRange) {
    @if (algolia$ | async; as algolia) {
        <app-product-list [instantSearchConfig]="algolia.instantSearchConfig"
                          [searchParameters]="algolia.searchParameters"
                          [emptyState]="emptyState"
                          [clearRefinementsCommands$]="clearRefinementsCommands$"
                          [hideBrandFilter]="true"
                          [listType]="listType"
        ></app-product-list>
    }
}
